import { useCallback } from 'react';
import styles from './style.module.scss';
import { PageHeader } from 'components';
import { Divider, Table } from 'antd';
import Filters from 'components/filters';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useBoardDocsPromotions } from '../useBoardDocsPromotions';
import DeleteModal from 'components/deleteModalView';

const CompaniesMainPage = () => {
  const {
    columns,
    data,
    loading,
    handleChangeFilters,
    handleCloseFilter,
    filters,
    onChangeTableFilter,
  } = useBoardDocsPromotions();
  const navigate = useNavigate();

  const handleOnRow = useCallback(
    (record, rowIndex) => {
      return {
        onClick: () => {
          navigate(`/boarddocs/promotions/${record.id}`);
        },
      };
    },
    [navigate],
  );

  return (
    <>
      <PageHeader title={'PROMOZIONI PER I DIPENDENTI'} />
      <div className={styles.container}>
        <Filters
          filters={filters}
          onChange={handleChangeFilters}
          onClose={handleCloseFilter}
        />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.promotions}
          pagination={data.pagination}
          onRow={handleOnRow}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 1000 }}
          // bordered
        />
      </div>
      <Routes>
        <Route path={':id/delete'} element={<DeleteModal />} />
      </Routes>
    </>
  );
};

export default CompaniesMainPage;
